'use client';

import React, { useRef } from 'react';
import { selectIsAuthSuccessOrPerpetual, selectIsAuthPending, useAppSelector, store, setIsCommonSsoModalVisible } from '@repo/web-store';
import IndicesFilterModal from './IndicesFilterModal';
import type { MarketTodayActionsProps } from '../../interfaces/MarketToday.interface';

const MarketTodayActions: React.FC<MarketTodayActionsProps> = ({ modalData, stockData, content, onDataRefresh }) => {
  const isLoggedIn = useAppSelector(selectIsAuthSuccessOrPerpetual);
  const isAuthPending = useAppSelector(selectIsAuthPending);
  const modalRef = useRef<{ open: () => void }>(null);

  const handleLoginClick = () => {
    if (!isAuthPending && !isLoggedIn) {
      store.dispatch(setIsCommonSsoModalVisible(true));
    }
  };

  const handleModalOpen = () => {
    modalRef.current?.open();
  };

  if (isLoggedIn) {
    return (
      <>
        <button 
          onClick={handleModalOpen} 
          className="border-0 bg-transparent cursor-pointer"
          aria-label="Edit indices"
        >
          <i className="bf-icon-pencil-edit text-orange-500 text-2xl md:text-xl inline-block align-middle" />
        </button>
        <IndicesFilterModal ref={modalRef} modalData={modalData} stockData={stockData} content={content} onDataRefresh={onDataRefresh} />
      </>
    );
  }

  return (
    <button 
      onClick={handleLoginClick} 
      className="border-0 bg-transparent cursor-pointer"
      aria-label={isAuthPending ? "Logging in..." : "Login to edit indices"}
      disabled={isAuthPending}
    >
      <i className="bf-icon-pencil-edit text-orange-500 text-2xl md:text-xl inline-block align-middle" />
    </button>
  );
};

export default MarketTodayActions;